import * as React from 'react'
import HeroText from './HeroText'
import MulticolImage from './MulticolImage'
import TestimonialBlock from './TestimonialBlock'

const InnerBlock = ({ _type, ...props }) => {
  switch (_type) {
    case 'heroText': return <HeroText {...props} />
    case 'imageWithCaption': return <MulticolImage {...props} />
    case 'testimonial': return <TestimonialBlock {...props} />
    default: return <div data-type={_type} />
  }
}

export default InnerBlock
